const DATA_UNITS = ["Byte", "KiB", "MiB", "GiB", "TiB", "PiB", "EiB"];
function range(start, end) {
  const ret = Array(end - start + 1);
  for (let i = 0; start <= end; i++, start++) {
    ret[i] = start;
  }
  return ret;
}
function isRangeIntersected(a, b) {
  if (a[0] > a[1]) {
    a = [a[1], a[0]];
  }
  if (b[0] > b[1]) {
    b = [b[1], b[0]];
  }
  return b[0] <= a[0] && a[0] <= b[1] || b[0] <= a[1] && a[1] <= b[1] || a[0] <= b[0] && b[0] <= a[1] || a[0] <= b[1] && b[1] <= a[1];
}
function formatDataSize(bytes, acc = 2) {
  let i = 0;
  const zero = 0;
  while (bytes >= 1024) {
    i++;
    bytes /= 1024;
  }
  return {
    "size": bytes > 0 ? bytes.toFixed(acc) : zero.toFixed(acc),
    "unit": DATA_UNITS[i]
  };
}
function randomBetween(min, max) {
  if (max < min) {
    [min, max] = [max, min];
  }
  return (max - min) * Math.random() + min;
}
function randomIntegerBetween(min, max) {
  if (max < min) {
    [min, max] = [max, min];
  }
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor((max - min) * Math.random() + min);
}
class Accalculator {
  constructor(finalAccuracy = 2, extendedAccuracy = 2) {
    this.finalAccuracy = finalAccuracy;
    this.extendedAccuracy = extendedAccuracy;
  }
  _toFloat(a) {
    return typeof a === "number" ? a : parseFloat(a);
  }
  /**
   * 将一个数值转换为较高精度数值。
   *
   * @param value     待转换数值。
   */
  protect(value) {
    return this._toFloat(value).toFixed(this.finalAccuracy + this.extendedAccuracy);
  }
  /**
   * 将一个高精度数值转换成最终目标精度的数值。
   *
   * @param value     待转换数值。
   */
  finalize(value) {
    return this._toFloat(value).toFixed(this.finalAccuracy);
  }
  /**
   * 进行高精度加法计算，并返回高精度的数值。
   *
   * @param a     加数1
   * @param b     加数2
   */
  add(a, b) {
    return this.protect(this._toFloat(a) + this._toFloat(b));
  }
  /**
   * 进行高精度乘法计算，并返回高精度的数值。
   *
   * @param a     因数1
   * @param b     因数2
   */
  mul(a, b) {
    return this.protect(this._toFloat(a) * this._toFloat(b));
  }
  /**
   * 进行高精度除法计算，并返回高精度的数值。
   *
   * @param a     被除数
   * @param b     除数
   */
  div(a, b) {
    return this.protect(this._toFloat(a) / this._toFloat(b));
  }
}
export {
  Accalculator,
  formatDataSize,
  isRangeIntersected,
  randomBetween,
  randomIntegerBetween,
  range
};
//# sourceMappingURL=Number.js.map
